export default __webpack_public_path__ + "static/media/litho-demo-vertical-portfolio.10a9d808.jpg";